// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
export var selectBestSavingsAccounts = function selectBestSavingsAccounts(identity) {
  return get(identity, 'banking.bestSavingsAccounts');
};
export var selectBanks = function selectBanks(identity) {
  return get(identity, 'banking.banks');
};